import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from './../../../redux/hooks';
import { useLocation, useNavigate } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';

type Props = {
item: any,
index: number,
sidebarWidth: number;
};

const SidebarItem: React.FC<Props> = ({ item, index, sidebarWidth }) => {
const navigate = useNavigate();
const location = useLocation();
const { t } = useTranslation();
const isMobile = useMediaQuery('(max-width:600px)');

const colors = useAppSelector(state => state.theme.colors);
const [iconUrl, setIconUrl] = useState('');

// FIX: Determine the base path (e.g., '/dashboard', '/settings') from the current URL.
const basePath = `/${location.pathname.split('/')[1]}`;

const changeSection = (sectionName: string) => {
    if (sectionName && (item.type === 'item')) {
        // FIX: Navigate relative to the current base path, not just '/dashboard'.
        navigate(`${basePath}/${sectionName}`);
    };
};

useEffect(() => {
  const icons: { [key: string]: string } = {
    'docs': require('../../../assets/icons/navigation/documents.png'),
    'patients': require('../../../assets/icons/navigation/patients.png'),
    'templates': require('../../../assets/icons/navigation/templates.png'),
    'charting': require('../../../assets/icons/navigation/charting.png'),
    'preferences': require('../../../assets/icons/navigation/theme.png'),
    'account': require('../../../assets/icons/navigation/account.png'),
    'help': require('../../../assets/icons/navigation/help.png'),
    'history': require('../../../assets/icons/navigation/history.png'),
    'hackers': require('../../../assets/icons/navigation/hackers.png'),
    'doctors': require('../../../assets/icons/navigation/doctors.png'),
    'tickets': require('../../../assets/icons/navigation/tickets.png'),
    'data': require('../../../assets/icons/navigation/data.png'),
    'group': require('../../../assets/icons/navigation/group.png'),
    'groups': require('../../../assets/icons/navigation/groups.png'),
    'create': require('../../../assets/icons/navigation/add.png'),
    'billing': require('../../../assets/icons/navigation/billing.png'),
    'plans': require('../../../assets/icons/navigation/plans.png'),
    'referrals': require('../../../assets/icons/navigation/referrals.png'),
    'team': require('../../../assets/icons/navigation/team.png'),
    'faxLogs': require('../../../assets/icons/navigation/fax.png'),
  };
  setIconUrl(icons[item.text] || '');
},[item]);

const showText = sidebarWidth >= 100;
// FIX: The component is "active" if the current URL path starts with its section path, relative to the current base path.
const isActive = location.pathname.startsWith(`${basePath}/${item.section}`);

return (
    <>
    { !item?.hidden &&
    <Box
      onClick={() => changeSection(item.section)}
      key={index}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '85%',
        minHeight: item.type === 'item' ? (isMobile ? 60 : 80) : 10,
        height: 'auto',
        borderRadius: 2,
        marginBottom: 1,
        paddingY: 1,
        cursor: item.type === 'header' ? 'auto' : 'pointer',
        backgroundColor: isActive ? colors?.sidebarSelectedItemBackground : 'transparent',
        color: isActive ? colors?.sidebarItemSelectedSection : colors?.sidebarUnselectedItem,
        '&:hover': {
          backgroundColor: item.type === 'item' ? (isActive ? colors?.sidebarSelectedItemBackground : colors?.sidebarItemHover) : 'transparent'
        }
      }}
    >
      { ((item.type === 'item') && iconUrl) &&
        <Box
            component="img"
            sx={{
                width: isMobile ? 25 : 30,
                height: isMobile ? 25 : 30,
                objectFit: 'contain',
            }}
            src={iconUrl}
            alt={String(t(item.text))}
        />}
      { (item.type === 'item' && showText) &&
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          fontSize: 10,
          paddingX: 0.5,
          marginTop: 0.5,
          textAlign: 'center',
          color: isActive ? colors?.highlightedText: colors?.text,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      >{t(item.text)}</Box>}
    </Box>}
    </>
);

};

export default SidebarItem;